import { createContext } from "react";
import { Authorization } from "@teamrota/authlib";

export const NOT_AUTHED = new Authorization({ authed: false });

export const AuthContext = createContext();
